module.exports = __webpack_public_path__ + "img/ring_g_s_0_1.075056ab.png";